import { enMessages } from './../config/validationMessages/en';
import { svMessages } from './../config/validationMessages/sv';
import { noMessages } from './../config/validationMessages/no';
import { daMessages } from './../config/validationMessages/da';

export function initGlobalValidationHandlers(): void {
    // --- Global defaults ---
    $.validator.setDefaults({
        errorPlacement: (error, element) => {
            console.log('errorPlacement...', error, element);
        }
    });

    // --- Custom validation methods ---
    $.validator.addMethod(
        'alphanumeric',
        function (this: any, value: string, element: Element) {
            return this.optional(element) ||
                /^[A-Za-zÀ-ÖØ-öø-ÿ0-9\-.,'"!?+=&\s]+$/i.test(value);
        },
        $.validator.messages.alphanumeric
    );

    $.validator.addMethod(
        'reviewrange',
        function (this: any, value: string, element: Element, params: number[]) {
            return this.optional(element) ||
                (Number(value) >= params[0] && Number(value) <= params[1]);
        },
        $.validator.messages.reviewrange
    );

    $.validator.addMethod(
        'alphanumericRestricted',
        function (this: any, value: string, element: Element) {
            return this.optional(element) ||
                /^[A-Za-zÀ-ÖØ-öø-ÿ0-9\-_\\s]+$/i.test(value);
        },
        $.validator.messages.alphanumericRestricted
    );

    $.validator.addMethod(
        'phoneNumber',
        function (this: any, value: string, element: Element) {
            return this.optional(element) ||
                /^[0-9+\-()\\s]+$/i.test(value);
        },
        $.validator.messages.phoneNumber
    );

    $.validator.addMethod(
        'email',
        function (this: any, value: string, element: Element) {
            return (
                /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(value)
            );
        },
        $.validator.messages.email
    );

    $.validator.addMethod(
        'noSpace',
        function (this: any, value: string, element: Element) {
            return value.indexOf(' ') < 0 && value !== '';
        },
        $.validator.messages.noSpace
    );

    $.validator.addMethod(
        'passwordCheck',
        function (this: any, value: string, element: Element) {
            if (this.optional(element)) return true;
            if (!/[A-Z]/.test(value)) return false;
            if (!/[a-z]/.test(value)) return false;
            if (!/[0-9]/.test(value)) return false;
            return true;
        },
        $.validator.messages.passwordCheck
    );
}

export function setValidationMessages(culture: string) {
    let messages;

    switch (culture) {
        case 'en':
            messages = enMessages;
            break;
        case 'sv':
            messages = svMessages;
            break;
        case 'no':
            messages = noMessages;
            break;
        case 'da':
            messages = daMessages;
            break;
        default:
            messages = enMessages; // fallback to English
    }

    $.extend($.validator.messages, messages);
}